import React from 'react';
import { Col } from 'antd';

import Error from '../Error';

import { Container } from './styles';

export default function FormControl({
  cols = null,
  children,
  label = null,
  error = null,
  field,
  required = false,
  list = false,
  ...props
}) {
  const content = (
    <Container className={`form-control ${error ? 'error' : ''}`} list={list} {...props}>
      {label && (
        <label htmlFor={field} {...props}>
          {label} {required && <span className="field-required">*</span>}
        </label>
      )}
      {children}
      <Error msg={error} />
    </Container>
  );

  return cols ? (
    <Col xs={cols.xs || cols.span} sm={cols.sm} md={cols.md} lg={cols.lg} xl={cols.xl}>
      {content}
    </Col>
  ) : (
    content
  );
}
